import { Box, Heading } from '@npco/zeller-design-system'

import { BulletPointList } from '../../../../../components/BulletPointList/BulletPointList'

interface AccountFeatureListProps {
  title: string
  points: string[] | React.ReactNode[]
}

export const AccountFeatureList = ({
  title,
  points,
}: AccountFeatureListProps) => (
  <Box>
    <Heading.H3 m="0 0 8px 0">{title}</Heading.H3>
    <BulletPointList points={points} />
  </Box>
)
